<template>
  <main>
    <section class="row">
      <div class="col-md-2">
        <q-input dense outlined v-model="motivo" label="Motivo" />
      </div>
      <div class="col-md-3 q-ml-sm">
        <q-input
          dense
          outlined
          v-model="observacao"
          label="Observação de texto longo"
        />
      </div>
    </section>

    <div v-if="rows.length <= 0" class="q-mt-lg">
      <span
        class="row q-pa-md col-12 text-bold text-black texto-alerta"
        style="background-color: #b3e5be; border-radius: 5px"
        >Selecione os produtos que deseja movimentar!</span
      >
    </div>
    <div v-else class="q-mt-lg">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :filter="filter"
        :rows="rows"
        :columns="columns"
        class="tabela-tamanho-fixo"
        dense
        :loading="disable"
        v-model:pagination="pagination"
        hide-pagination
      >
        <template #body-cell-code="props">
          <q-td>
            <span>
              {{ props.row.codigo_produto || props.row.code }}
            </span>
          </q-td>
        </template>
        <template #body-cell-description="props">
          <q-td>
            <span>
              {{ props.row.descricao_do_produto || props.row.description }}
            </span>
          </q-td>
        </template>
        <template #body-cell-link="props">
          <q-td>
            <span v-if="props.row.codigo_ca">
              {{ props.row.codigo_ca }}
            </span>
            <span v-else-if="props.row.ca && props.row.ca.code">
              {{ props.row.ca.code }}
            </span>
          </q-td>
        </template>
        <template #body-cell-estoque="props">
          <q-td>
            <span v-if="props.row.qtd_estoque !== undefined">
              {{ props.row.qtd_estoque }}
            </span>
            <span v-else-if="props.row.stock && props.row.stock[0]">
              {{ Math.trunc(props.row.stock[0].pivot.amount) }}
            </span>
          </q-td>
        </template>
        <template #body-cell-tipo="props">
          <q-td>
            <span>
              <q-select
                :options="filtros"
                label="Selecione o Tipo"
                dense
                outlined
                v-model="props.row.type"
              />
            </span>
          </q-td>
        </template>
        <template #body-cell-quantidade="props">
          <q-td>
            <span class="col-2">
              <q-input
                dense
                outlined
                v-model="props.row.amount"
                label="Quantidade"
                max-length="7"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              />
            </span>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <div class="q-mt-md">
      <q-btn
        color="positive"
        icon="add"
        dense
        no-caps
        label="Criar nova movimentação"
        @click="criar"
      />
    </div>
  </main>
</template>

<script>
const columns = [
  {
    name: "code",
    label: "Código",
    field: (row) => row.codigo_produto || row.code,
    align: "left",
  },
  {
    name: "description",
    label: "Descrição",
    field: (row) => row.descricao_do_produto || row.description,
    align: "left",
  },
  {
    name: "link",
    label: "CA",
    field: "link",
    align: "left",
  },
  {
    name: "tipo",
    label: "Tipo",
    field: "tipo",
    align: "left",
  },
  {
    name: "estoque",
    label: "Estoque",
    field: "estoque",
    align: "left",
  },
  {
    name: "quantidade",
    label: "Quantidade",
    field: "quantidade",
    align: "left",
  },
];

import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

export default {
  props: ["produtos"],
  setup(props, { emit }) {
    const store = useStore();

    const link = ref("");
    const $q = useQuasar();

    const rows = ref([]);
    const disable = ref(true);
    const observacao = ref("");
    const motivo = ref("");
    let filter = ref("");

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 50,
      rowsNumber: 15,
    });

    const criar = async () => {
      try {
        const productsToSend = rows.value.map(row => ({
          id: row.id_produto || row.produto_id || row.id,
          type: row.type,
          amount: row.amount
        }));

        await store.dispatch("ajusteEstoque/mudarEstoque", {
          vendor_id: store.state.org.unidadeData.id,
          motivo: motivo.value,
          observacao: observacao.value,
          products: productsToSend,
        });
        $q.notify({
          message: "Ajustado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("resetarProdutos");
      } catch (error) {
        $q.notify({
          message: "Erro a o ajustar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => props.produtos,
      () => {
        rows.value = props.produtos;
        if (rows.value.length == 0) {
          disable.value = true;
        } else {
          disable.value = false;
        }
      }
    );

    return {
      columns,
      rows,
      pagination,
      disable,
      filter,
      link,
      criar,
      observacao,
      motivo,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),

      filtros: ["Entrada", "Saída"],
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
